const TextBlockSchema = (data) => {
  // Remove o "Advanced settings" do bloco de texto.
  // TODO: remover customização quando o TOC (table of contents) for habilitado.
  // Customização
  return {
    title: '',
    fieldsets: [
      {
        id: 'default',
        title: 'Default',
        fields: [],
      },
    ],
    properties: {},
    required: [],
  };
  // Fim da customização
};

export default TextBlockSchema;
